import React, { useState } from 'react';

const FavouriteButton = ({
	highlighted,
	onClick,
	className,
	wrapperSizePx = 24,
	starSizePx = 16,
}: {
	highlighted: boolean;
	onClick: React.MouseEventHandler<HTMLDivElement>;
	className?: string;
	wrapperSizePx?: number;
	starSizePx?: number;
}) => {
	const [toggleAnimation, setToggleAnimation] = useState('');

	return (
		<div
			className={`w-[${wrapperSizePx}px] h-[${wrapperSizePx}px] flex items-center justify-center`}
			onClick={(e) => {
				onClick(e);
				if (!highlighted) {
					setToggleAnimation('is_animating');
				}
			}}
		>
			<div
				onAnimationEnd={() => setToggleAnimation('')}
				className={`hover:cursor-pointer star ${
					highlighted ? 'star-faved' : ''
				} ${toggleAnimation} w-[${starSizePx}px] h-[${starSizePx}px] ${className}`}
			/>
		</div>
	);
};

export default FavouriteButton;
